export default __webpack_public_path__ + "static/media/insert-drive-file.bf12bde9.svg";